var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block"},[_c('footer',{staticClass:"footer"},[_vm._v(" Copyright © 2011-"+_vm._s(new Date().getFullYear())+" "+_vm._s(this.$appInfo.title)+" Inc. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }